module.exports = __webpack_public_path__ + "static/media/loans.81901cc1.svg";